/* Make select options capitalized first letter
================================================== */
	(() => {
		const SELECTOR = 'select';
		function capitalizeFirstLetter(str) {
			if (!str) return str;
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
		function normalizeOptionText(text) {
			return capitalizeFirstLetter(text.toLowerCase());
		}
		function fixSelectOptions(selectEl) {
			selectEl.querySelectorAll('option').forEach((opt) => {
				if (opt.dataset.capDone === '1') return;

				const text = opt.textContent?.trim();
				if (!text) return;

				opt.textContent = normalizeOptionText(text);
				opt.dataset.capDone = '1';
			});
		}
		function init(root = document) {
			root.querySelectorAll(SELECTOR).forEach(fixSelectOptions);
		}
		// First run
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => init(), { once: true });
		} else {
			init();
		}
		// Catch DOM updates (AJAX, drawer, app, ecc.)
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return;
					if (node.matches?.('select')) {
						fixSelectOptions(node);
					} else if (node.querySelectorAll) {
						init(node);
					}
				});
			});
		});

		observer.observe(document.documentElement, {
			childList: true,
			subtree: true
		});
	})();
/* End of customize select options capitalization
================================================== */

/**
 * Capitalize text content:
 * - trasforma tutto in lowercase
 * - rende maiuscola solo la prima lettera
 *
 * Aggiungi nuovi selettori nell'array `selectors`
 */

(function () {
	const selectors = [
		'.product__block .accordion-details h1',
		'.product__block .accordion-details h2',
		'.product__block .accordion-details h3',
		'.product__block .accordion-details h4',
		'.product__block .accordion-details h5',
		'.product__block .accordion-details h6',
		'.product__title',
		'.cart-item__details a',
		'.product__block--complementary .f-column .product-card__title a',
		'[data-capitalize]',
		'.pickup-availability-drawer-title',
		'.quick-view.modal.drawer .product__block--title .product__title'
		// '.altro-selettore',
	];

	function capitalizeFirstLetter(text) {
		if (!text) return '';
		const clean = text.trim().toLowerCase();
		if (!clean) return '';
		return clean.charAt(0).toUpperCase() + clean.slice(1);
	}

	function shouldSkipElement(el) {
		// Evita campi input/textarea o elementi editabili
		if (!el || el.nodeType !== 1) return true;
		const tag = el.tagName;
		if (tag === 'INPUT' || tag === 'TEXTAREA') return true;
		if (el.isContentEditable) return true;

		// Se dentro ci sono nodi "strutturali" tipo img/svg/video ecc, meglio non toccare textContent
		// (perché textContent riscrive tutto il subtree e può spaccare cose)
		if (el.querySelector('img, svg, video, picture, source')) return true;

		return false;
	}

	function applyToElement(el) {
		if (shouldSkipElement(el)) return;

		// Se l'elemento ha child element (es. <a><h2>...</h2></a>)
		// allora evitare di riscrivere il wrapper: prova a capitalizzare SOLO il primo nodo di testo "reale"
		const hasElementChildren = Array.from(el.childNodes).some(n => n.nodeType === 1);

		if (hasElementChildren) {
			// prova a capitalizzare i text node diretti (non quelli dentro i figli)
			const textNodes = Array.from(el.childNodes).filter(n => n.nodeType === 3);
			textNodes.forEach(n => {
				const original = n.nodeValue;
				const formatted = capitalizeFirstLetter(original);
				if (formatted && original !== formatted) {
					n.nodeValue = formatted;
				}
			});

			// inoltre, se ci sono figli, capitalizza anche loro MA senza uscire dal perimetro dei selettori:
			// qui non facciamo nulla, perché ci pensa applyCapitalization con i suoi selettori.
			return;
		}

		// Caso semplice: solo testo
		const original = el.textContent;
		const formatted = capitalizeFirstLetter(original);

		if (formatted && original !== formatted) {
			el.textContent = formatted;
		}
	}

	function applyCapitalization(scope = document) {
		selectors.forEach(selector => {
			scope.querySelectorAll(selector).forEach(el => {
				applyToElement(el);
			});
		});
	}

	// DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => applyCapitalization());
	} else {
		applyCapitalization();
	}

	// Shopify editor / section reload
	document.addEventListener('shopify:section:load', e => {
		applyCapitalization(e.target);
	});

	// Contenuti dinamici (variant change, quick view, ajax cart, ecc.)
	// Observer leggero: quando arrivano nodi nuovi, capitalizza SOLO dentro quei nodi.
	const observer = new MutationObserver(mutations => {
		for (const m of mutations) {
			if (m.type !== 'childList' || !m.addedNodes.length) continue;

			m.addedNodes.forEach(node => {
				if (node.nodeType !== 1) return; // solo elementi
				applyCapitalization(node);
			});
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();
/* Viewport Toggle: hide targets when triggers are in viewport
================================================== */
	// (() => {
	// 	const CONFIGS = [
	// 		{
	// 			triggerSelector: '.product-form',
	// 			targetSelector: '.sticky-add-to-cart',
	// 			className: 'hide-element',
	// 			rootMargin: '0px 0px -20% 0px',
	// 			threshold: 0.15,
	// 			removeOnExit: true
	// 		}
	// 	];

	// 	if (!('IntersectionObserver' in window)) return;
	// 	if (!CONFIGS.length) return;

	// 	const instances = [];

	// 	function toArray(nodeList) {
	// 		return Array.prototype.slice.call(nodeList || []);
	// 	}

	// 	function uniqueKey(cfg) {
	// 		return `${cfg.triggerSelector}__${cfg.targetSelector}__${cfg.className}`;
	// 	}

	// 	function normalizeConfig(cfg) {
	// 		return {
	// 			triggerSelector: cfg.triggerSelector,
	// 			targetSelector: cfg.targetSelector,
	// 			className: cfg.className || 'is-hidden',
	// 			root: cfg.root || null,
	// 			rootMargin: cfg.rootMargin || '0px',
	// 			threshold: typeof cfg.threshold === 'number' ? cfg.threshold : 0.1,
	// 			removeOnExit: cfg.removeOnExit !== false, // default true
	// 		};
	// 	}

	// 	function createInstance(cfg) {
	// 		const key = uniqueKey(cfg);

	// 		const state = {
	// 			key,
	// 			cfg,
	// 			triggers: [],
	// 			targets: [],
	// 			inViewCount: 0,
	// 			observer: null,
	// 		};

	// 		const refreshNodes = (scope = document) => {
	// 			// Nota: scope qui serve solo per ridurre lavoro, ma ricerchiamo globalmente per coerenza
	// 			state.triggers = toArray(document.querySelectorAll(cfg.triggerSelector));
	// 			state.targets = toArray(document.querySelectorAll(cfg.targetSelector));
	// 		};

	// 		const apply = (hide) => {
	// 			if (!state.targets.length) return;

	// 			state.targets.forEach((t) => {
	// 				if (!t || !(t instanceof HTMLElement)) return;
	// 				t.classList.toggle(cfg.className, hide);
	// 			});
	// 		};

	// 		const handleIntersect = (entries) => {
	// 			let delta = 0;

	// 			entries.forEach((entry) => {
	// 				// entry.isIntersecting indica se QUEL trigger è in viewport secondo threshold/rootMargin
	// 				if (entry.isIntersecting) delta += 1;
	// 				else delta -= 1;
	// 			});

	// 			// clamp: evitiamo numeri strani se il browser manda eventi in batch
	// 			state.inViewCount = Math.max(0, state.inViewCount + delta);

	// 			if (state.inViewCount > 0) {
	// 				apply(true);
	// 			} else if (cfg.removeOnExit) {
	// 				apply(false);
	// 			}
	// 		};

	// 		const connectObserver = () => {
	// 			if (state.observer) return;

	// 			state.observer = new IntersectionObserver(handleIntersect, {
	// 				root: cfg.root,
	// 				rootMargin: cfg.rootMargin,
	// 				threshold: cfg.threshold,
	// 			});

	// 			state.triggers.forEach((tr) => {
	// 				if (!tr || !(tr instanceof HTMLElement)) return;
	// 				state.observer.observe(tr);
	// 			});
	// 		};

	// 		const disconnectObserver = () => {
	// 			if (!state.observer) return;
	// 			try {
	// 				state.observer.disconnect();
	// 			} catch (e) {}
	// 			state.observer = null;
	// 			state.inViewCount = 0;
	// 		};

	// 		const init = () => {
	// 			refreshNodes();

	// 			// se non abbiamo nodi, non connettiamo nulla
	// 			if (!state.triggers.length || !state.targets.length) return;

	// 			connectObserver();
	// 		};

	// 		const reinit = () => {
	// 			// Rebuild: utile quando arrivano nuovi nodi (drawer, quick view, section reload, ajax)
	// 			disconnectObserver();
	// 			init();
	// 		};

	// 		init();

	// 		return {
	// 			key,
	// 			reinit,
	// 			refresh: refreshNodes,
	// 			disconnect: disconnectObserver,
	// 		};
	// 	}

	// 	function initAll() {
	// 		CONFIGS
	// 			.map(normalizeConfig)
	// 			.forEach((cfg) => {
	// 				instances.push(createInstance(cfg));
	// 			});
	// 	}

	// 	// DOM ready
	// 	if (document.readyState === 'loading') {
	// 		document.addEventListener('DOMContentLoaded', initAll, { once: true });
	// 	} else {
	// 		initAll();
	// 	}

	// 	// Shopify section reload (editor / ajax sections)
	// 	document.addEventListener('shopify:section:load', () => {
	// 		instances.forEach((i) => i.reinit());
	// 	});

	// 	// Contenuti dinamici: reinit quando entrano nodi che potrebbero matchare trigger/target
	// 	// Observer: leggero, non fa query su ogni mutation, ma solo quando arrivano element nodes.
	// 	const mo = new MutationObserver((mutations) => {
	// 		for (const m of mutations) {
	// 			if (m.type !== 'childList' || !m.addedNodes.length) continue;

	// 			let foundElement = false;

	// 			m.addedNodes.forEach((node) => {
	// 				if (foundElement) return;
	// 				if (node && node.nodeType === 1) foundElement = true;
	// 			});

	// 			if (foundElement) {
	// 				instances.forEach((i) => i.reinit());
	// 				break;
	// 			}
	// 		}
	// 	});

	// 	mo.observe(document.body, {
	// 		childList: true,
	// 		subtree: true
	// 	});
	// })();
/* End of Viewport Toggle
================================================== */
/* ==========================================================
	Track order drawer: smooth close (clip-path)
========================================================== */
(() => {
	const SELECTOR = 'details.track-order--drawer';
	const CLOSING_CLASS = 'is-closing';

	function getRevealDurationMs(details){
		const panel = details.querySelector('.track-order__panel');
		if(!panel) return 0;

		const styles = getComputedStyle(panel);
		const dur = styles.transitionDuration.split(',')[0]?.trim() || '0s';
		const ms = dur.endsWith('ms') ? parseFloat(dur) : parseFloat(dur) * 1000;

		return Number.isFinite(ms) ? ms : 0;
	}

	function init(details){
		const summary = details.querySelector('summary');
		const panel = details.querySelector('.track-order__panel');
		if(!summary || !panel) return;

		summary.addEventListener('click', (e) => {
			if(details.classList.contains(CLOSING_CLASS)){
				e.preventDefault();
				return;
			}

			/* Close animato */
			if(details.open){
				e.preventDefault();

				details.classList.add(CLOSING_CLASS);

				panel.style.clipPath = ' polygon(0 0, 0 0, 0 100%, 0% 100%)';
				panel.style.pointerEvents = 'none';

				const dur = getRevealDurationMs(details) || 350;

				window.setTimeout(() => {
					details.open = false;
					details.classList.remove(CLOSING_CLASS);

					panel.style.clipPath = '';
					panel.style.pointerEvents = '';
				}, dur);
			}
		});
	}

	function boot(){
		document.querySelectorAll(SELECTOR).forEach(init);
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', boot);
	}else{
		boot();
	}
})();
/* ==========================================================
	Track Order – Close on outside click (desktop only)
========================================================== */
(() => {

	const SELECTOR = 'details.track-order:not(.track-order--drawer)';
	const DESKTOP_QUERY = '(min-width: 1000px)';

	function isDesktop(){
		return window.matchMedia(DESKTOP_QUERY).matches;
	}

	function init(details){

		document.addEventListener('click', (event) => {

			/* Solo desktop */
			if(!isDesktop()) return;

			/* Se non è aperto, ignora */
			if(!details.open) return;

			/* Se clicco dentro il component, ignora */
			if(details.contains(event.target)) return;

			/* Altrimenti chiudi */
			details.open = false;

		});

	}

	function boot(){
		document.querySelectorAll(SELECTOR).forEach(init);
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', boot);
	}else{
		boot();
	}

})();
/* ==========================================================
	REMOVE IUBENDA FLOATING TOGGLE
========================================================== */
(() => {
	const SELECTORS = [
		'.iubenda-floatable-default-btn',
		'.iubenda-tp-btn.iubenda-floatable-tb-btn',
		'.iubenda-uspr-btn',
		'.iubenda-tp-btn.iubenda-cs-preferences-link',
		'.iubenda-tp-btn'
	];

	function removeToggle(root = document) {
		SELECTORS.forEach(selector => {
			root.querySelectorAll(selector).forEach(el => {
				el.remove();
			});
		});
	}

	// First cleanup
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => removeToggle());
	} else {
		removeToggle();
	}

	// Observe DOM changes because Iubenda may reinject it
	const observer = new MutationObserver((mutations) => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (!(node instanceof HTMLElement)) return;

				SELECTORS.forEach(selector => {
					if (node.matches?.(selector)) {
						node.remove();
					}
					node.querySelectorAll?.(selector).forEach(el => el.remove());
				});
			});
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();
/* ==========================================================
	EQUAL-HEIGHT PRODUCT CARDS IN SLIDERS
	Swiper stretches the slides to equal height, but not the card inside
	(the slide is a block-level element). A percentage height on the card
	conflicts with the card padding + Swiper's fixed container height and
	overflows onto the controls. So we equalize in JS: reset, measure the
	tallest card, then apply that exact pixel height to every card in the
	same slider group.
========================================================== */
(() => {
	const GROUP = '.swiper-equal-height';
	const CARD = '.product-card';

	function equalizeGroup(group) {
		const cards = group.querySelectorAll(CARD);
		if (cards.length < 2) return;
		// Reset to natural height first so we measure real content height.
		cards.forEach((c) => { c.style.height = ''; c.style.boxSizing = ''; });
		let max = 0;
		cards.forEach((c) => {
			const h = c.getBoundingClientRect().height;
			if (h > max) max = h;
		});
		// The card is content-box; force border-box so the applied pixel height
		// equals the measured (border-box) height and doesn't add the padding on top.
		if (max > 0) cards.forEach((c) => {
			c.style.boxSizing = 'border-box';
			c.style.height = Math.ceil(max) + 'px';
		});
	}

	function equalizeAll() {
		document.querySelectorAll(GROUP).forEach(equalizeGroup);
	}

	// Debounce with setTimeout (not rAF: rAF is paused in background tabs).
	let scheduleTimer;
	function schedule() {
		clearTimeout(scheduleTimer);
		scheduleTimer = setTimeout(equalizeAll, 50);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', schedule);
	} else {
		schedule();
	}
	window.addEventListener('load', schedule);
	// Related/complementary products load via fetch and Swiper relayouts the
	// cards after init; re-run a few times so we equalize once everything settles.
	[300, 900, 1800].forEach((delay) => setTimeout(schedule, delay));

	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(schedule, 150);
	});

	// Recommendations load asynchronously (fetch). Observe ONLY those containers
	// (not the whole body) so we never run on unrelated DOM mutations / lazy-load
	// during scroll — keeps this cheap.
	document.querySelectorAll('product-recommendations').forEach((container) => {
		const obs = new MutationObserver(() => schedule());
		obs.observe(container, { childList: true, subtree: true });
	});
})();
/* ==========================================================
	STICKY ATC BAR — keep it docked to the live header bottom.
	The sticky header collapses, hides on scroll-down and reappears on
	scroll-up; anchoring the bar to a static --header-height leaves a gap
	(e.g. when scrolling back to top). Instead we track the header's real
	bottom edge, so the bar always sits flush under it (top:0 when hidden).
========================================================== */
(() => {
	const bar = document.querySelector('.sticky-atc-bar');
	if (!bar) return;
	const header =
		document.querySelector('.header-section .header') || document.querySelector('header.header');
	if (!header) return;

	function updateTop() {
		bar.style.top = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px';
	}

	// Lenis drives scrolling on its own rAF loop and does NOT reliably fire native
	// 'scroll' events, so the bar's top must be updated from Lenis' per-frame scroll
	// callback — otherwise it stays stuck at its initial value and a gap opens up
	// between the (shorter, scrolled) sticky header and the bar. window.lenis is set
	// by smooth-scroll.js on DOMContentLoaded, so retry until it exists.
	function bindLenis() {
		if (window.lenis && typeof window.lenis.on === 'function') {
			window.lenis.on('scroll', updateTop);
			return true;
		}
		return false;
	}
	if (!bindLenis()) {
		let tries = 0;
		const iv = setInterval(() => {
			if (bindLenis() || ++tries > 30) clearInterval(iv);
		}, 100);
	}

	// Fallbacks: native scroll (non-Lenis contexts), resize, the header's own
	// pin/unpin transition settle, and initial paint.
	let ticking = false;
	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(() => {
			ticking = false;
			updateTop();
		});
	}
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', updateTop, { passive: true });
	header.addEventListener('transitionend', updateTop);
	window.addEventListener('load', updateTop);
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateTop);
	} else {
		updateTop();
	}
})();
/* ==========================================================
	AI CHAT TEASER — closable "Sono Anna, come posso aiutarti?" tooltip that
	appears a few seconds after load next to the chat bubble to invite
	interaction. Works on mobile + desktop (anchored to the live bubble).
	Dismissal is remembered for the session; clicking the text opens the chat.
========================================================== */
(() => {
	const KEY = 'aiChatTeaserDismissed';
	const DELAY = 4000;
	const MESSAGE = 'Sono Anna, come posso aiutarti?';
	const OPEN_SELECTOR = '.shop-ai-chat-window.active';
	if (sessionStorage.getItem(KEY)) return;

	function build(chat) {
		const bubble = chat.querySelector('button');

		const tip = document.createElement('div');
		tip.className = 'ai-chat-teaser';
		tip.setAttribute('role', 'status');

		const text = document.createElement('button');
		text.type = 'button';
		text.className = 'ai-chat-teaser__text';
		text.textContent = MESSAGE;
		text.addEventListener('click', () => {
			dismiss();
			if (bubble) bubble.click();
		});

		const close = document.createElement('button');
		close.type = 'button';
		close.className = 'ai-chat-teaser__close';
		close.setAttribute('aria-label', 'Chiudi');
		close.innerHTML = '&times;';
		close.addEventListener('click', (e) => {
			e.stopPropagation();
			dismiss();
		});

		tip.appendChild(text);
		tip.appendChild(close);
		document.body.appendChild(tip);

		function position() {
			const r = chat.getBoundingClientRect();
			tip.style.right = Math.max(12, Math.round(window.innerWidth - r.right)) + 'px';
			tip.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
		}
		function show() {
			if (sessionStorage.getItem(KEY)) return;
			if (isChatOpen()) return; // the chat window is the primary UI — never show over it
			position();
			tip.classList.add('is-visible');
		}
		function hide() {
			tip.classList.remove('is-visible');
		}
		function dismiss() {
			hide();
			sessionStorage.setItem(KEY, '1');
		}

		/* The teaser only invites you to open the chat. Once the chat window is
		   open it is the primary UI and the teaser must never sit above it, so hide
		   it as soon as the window becomes active — whether opened via the bubble,
		   the teaser text or programmatically. */
		function isChatOpen() {
			return !!document.querySelector(OPEN_SELECTOR);
		}
		function hideWhenChatOpens() {
			if (!isChatOpen()) return;
			tip.classList.add('is-behind'); // drop below the window instantly...
			dismiss();                      // ...then fade out + remember for the session
			openObserver.disconnect();
		}
		const openObserver = new MutationObserver(hideWhenChatOpens);
		openObserver.observe(chat, { attributes: true, attributeFilter: ['class'], subtree: true });
		hideWhenChatOpens(); // catch a chat that is already open at build time

		window.addEventListener('resize', position, { passive: true });
		setTimeout(show, DELAY);
	}

	function boot() {
		const chat = document.querySelector('.shop-ai-chat-container');
		if (chat) {
			build(chat);
			return;
		}
		// The chat is a third-party app embed that may load late — retry briefly.
		let tries = 0;
		const iv = setInterval(() => {
			const el = document.querySelector('.shop-ai-chat-container');
			if (el) {
				clearInterval(iv);
				build(el);
			} else if (++tries > 40) {
				clearInterval(iv);
			}
		}, 250);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();